export default __webpack_public_path__ + "static/media/map.239fd2f6.svg";